import { useEffect, useState } from 'react'
import type { TenantBootstrapModel } from '@unified-lk/tenant-config'
import type { AuthSession } from '../../../../types/plans'
import { staffApi } from '../../../../api/staff'
import { dedupeVatechStudies, pickDefaultVatechStudy, type VatechCtCatalogResolved } from './domain/vatechCtCatalog'

export function usePatientVatechCtCatalog({
  bootstrap,
  session,
  lkPatientId,
  misPatientId,
  enabled = true,
}: {
  bootstrap: TenantBootstrapModel
  session: AuthSession
  lkPatientId: number | null
  misPatientId?: string | null
  enabled?: boolean
}) {
  const [catalog, setCatalog] = useState<VatechCtCatalogResolved | null>(null)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<unknown>(null)

  const reload = async () => {
    if (!enabled || !lkPatientId) {
      setCatalog(null)
      return
    }
    setIsLoading(true)
    setError(null)
    try {
      const data = await staffApi.getVatechCtCatalog(bootstrap, session, {
        lkPatientId,
        misPatientId: misPatientId ?? undefined,
      })
      setCatalog(data)
    } catch (err) {
      setError(err)
      setCatalog(null)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    void reload()
  }, [bootstrap, session, lkPatientId, misPatientId, enabled])

  return {
    catalog,
    studies: dedupeVatechStudies(catalog?.studies ?? []),
    isLoading,
    isError: Boolean(error),
    error,
    refetch: reload,
  }
}

export { pickDefaultVatechStudy }
